import { render } from "./CartSidebar.vue?vue&type=template&id=ccaddc86"
import script from "./CartSidebar.vue?vue&type=script&lang=js"
export * from "./CartSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__